/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDetailLookupResponseDto } from './AssetDetailLookupResponseDto';
import {
    AssetDetailLookupResponseDtoFromJSON,
    AssetDetailLookupResponseDtoFromJSONTyped,
    AssetDetailLookupResponseDtoToJSON,
    AssetDetailLookupResponseDtoToJSONTyped,
} from './AssetDetailLookupResponseDto';

/**
 * 
 * @export
 * @interface AssetDetailIncidentAffectedComponentResponseDto
 */
export interface AssetDetailIncidentAffectedComponentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentAffectedComponentResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentAffectedComponentResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailIncidentAffectedComponentResponseDto
     */
    serialNumber: string | null;
    /**
     * 
     * @type {AssetDetailLookupResponseDto}
     * @memberof AssetDetailIncidentAffectedComponentResponseDto
     */
    componentClass: AssetDetailLookupResponseDto | null;
}

/**
 * Check if a given object implements the AssetDetailIncidentAffectedComponentResponseDto interface.
 */
export function instanceOfAssetDetailIncidentAffectedComponentResponseDto(value: object): value is AssetDetailIncidentAffectedComponentResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('componentClass' in value) || value['componentClass'] === undefined) return false;
    return true;
}

export function AssetDetailIncidentAffectedComponentResponseDtoFromJSON(json: any): AssetDetailIncidentAffectedComponentResponseDto {
    return AssetDetailIncidentAffectedComponentResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailIncidentAffectedComponentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailIncidentAffectedComponentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'serialNumber': json['serialNumber'],
        'componentClass': AssetDetailLookupResponseDtoFromJSON(json['componentClass']),
    };
}

export function AssetDetailIncidentAffectedComponentResponseDtoToJSON(json: any): AssetDetailIncidentAffectedComponentResponseDto {
    return AssetDetailIncidentAffectedComponentResponseDtoToJSONTyped(json, false);
}

export function AssetDetailIncidentAffectedComponentResponseDtoToJSONTyped(value?: AssetDetailIncidentAffectedComponentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'serialNumber': value['serialNumber'],
        'componentClass': AssetDetailLookupResponseDtoToJSON(value['componentClass']),
    };
}

